import {
  CustomScrollInfiniteVirtualizer,
  WindowScrollInfiniteVirtualizer,
} from "common/components/Virtualizer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { useChatContext } from "../../context/ChatContext";
import ConversationItem from "./ConversationItem";

import type { JSX } from "react";
import type { Conversation } from "../../types";

interface ConversationsListProps {
  conversations: Conversation[] | undefined;
  canFetchNextPage: boolean;
  loadMoreConversations: () => void;
  endComponent: JSX.Element;
}

export default function ConversationsList({
  conversations,
  canFetchNextPage,
  loadMoreConversations,
  endComponent,
}: ConversationsListProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { activeConversation, setActiveConversation } = useChatContext();

  const conversationsComponents = conversations.map((conversation, index) => {
    const { conversation_urn: activeConversationUrn, owner: activeAccountId } =
      activeConversation || {};

    const { conversation_urn: conversationUrn, owner: accountId } =
      conversation;

    const isSelected =
      activeConversationUrn === conversationUrn &&
      activeAccountId === accountId;

    const isPreviousSelected =
      index >= 0 &&
      activeConversationUrn === conversations[index + 1]?.conversation_urn &&
      activeAccountId === conversations[index + 1]?.owner;

    return (
      <ConversationItem
        key={conversationUrn}
        isSelected={isSelected}
        isPreviousSelected={isPreviousSelected}
        conversation={conversation}
        onSelect={() => setActiveConversation(conversationUrn, accountId)}
        isLoading={false}
      />
    );
  });

  const commonProps = {
    canFetchNextPage,
    fetchNextPage: loadMoreConversations,
    estimatedItemSize: 108,
    endComponent,
  };

  if (isDesktop) {
    return (
      <div className="h-full overflow-y-auto scrollbar-thin [mask-image:_linear-gradient(to_bottom,_black_128px,_black_calc(100%-50px),transparent_100%)]">
        <CustomScrollInfiniteVirtualizer {...commonProps}>
          {conversationsComponents}
        </CustomScrollInfiniteVirtualizer>
      </div>
    );
  }
  return (
    <WindowScrollInfiniteVirtualizer {...commonProps}>
      {conversationsComponents}
    </WindowScrollInfiniteVirtualizer>
  );
}
